import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GridOptions } from 'ag-grid';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { DateHelper } from '../../../models/NgDateCustomAdapter';
import { AuthService } from '../../../services/auth.service';
import { PsDatosGeneralesService } from '../../../services/ps-datos-generales.service';
import { CellDateFormatterComponent } from '../../cell-date-formatter/cell-date-formatter.component';
import { CellHyperlinkCustomComponent } from '../../cell-hyperlink-custom/cell-hyperlink-custom.component';
import { ControlLookupComponent } from '../../control-lookup/control-lookup.component';
import { ClientesService } from '../../../services/clientes.service';
import { ClientesComponent } from '../../clientes/clientes.component';
import { AdvancedLookupComponent } from '../../../models/lookup';
import { SharedService } from '../../../services/shared.service';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { PsDatosGeneralesEditComponent } from '../ps-datos-generales-edit/ps-datos-generales-edit.component';
import { PsRevisionService } from '../../../services/ps-revision.service';

@Component({
  selector: 'app-ps-datos-generales-list',
  templateUrl: './ps-datos-generales-list.component.html',
  styleUrls: ['./ps-datos-generales-list.component.scss']
})
export class PsDatosGeneralesListComponent implements OnInit, AdvancedLookupComponent {

  @ViewChild('lookupCliente', { static: true }) lookupCliente: ControlLookupComponent;
  private searchSubject: Subject<string> = new Subject<string>();
  private importeSubject: Subject<void> = new Subject<void>();

  importe: any = "";
  clienteId: any = "";
  sectorId: any = "";
  estado: any = "";
  search: string = "";
  isLookup = false;

  public baseEditText = "Editar";

  public translate: TranslateService;
  public columnDefs: any[];
  public rowData: any;
  public gridApi;
  public tooltipShowDelay = 500
  // public gridApi;
  gridOptions: GridOptions;

  sectoresList: any;

  constructor(private _router: Router, private _route: ActivatedRoute, public _authService: AuthService, _translateService: TranslateService,
    private dateHelper: DateHelper, private psDatosGeneralesService: PsDatosGeneralesService, private _clientesService: ClientesService,
    private _sharedService: SharedService, public matDialog: MatDialog,
  ) {
    this.translate = _translateService;
    this._sharedService._boolValue.subscribe(data => {
      this.isLookup = data
    });
    this.columnDefs = this.createColumnDef();
    this.gridOptions = {
      floatingFiltersHeight: 50
    }
  }
  getSelectedItem() {
    if (this.gridApi.getSelectedNodes().length === 1) {
      const selectedRow = this.gridApi.getSelectedNodes()[0];
      const rowid = selectedRow.data.id;
      return rowid;

    } else {
      return null;
    }

  }

  ngOnInit() {
    this.translate.use(this.translate.currentLang);

    this.loadData();

    this.searchSubject.pipe(
      debounceTime(300)
    ).subscribe((searchText) => {
      this.handleSearch(searchText);
    });

    this.importeSubject.pipe(
      debounceTime(300)
    ).subscribe((importe) => {
      if (this.importe === null) {
        this.importe = ''
      }
      this.filterSubmit();
    });
  }


  createColumnDef() {
    const columnDefs = [
      {
        headerName: this.translate.instant('tasaciones.header_editar'), field: 'id', suppressFilter: true, suppressSorting: true,
        cellRendererFramework: CellHyperlinkCustomComponent,
        cellRendererParams: { destUrl: "/proyecto-significativo/edit/", hyperlinkText: "Editar" },
        pinned: 'left',
        width: 90,
        minWidth: 90,
        hide: this.isLookup
      },
      { headerName: 'Referencia PS', field: 'refPS' }, ,
      { headerName: 'Cliente', field: 'clienteNombre' },
      { headerName: 'Importe', field: 'importePresupuesto' },
      { headerName: 'Deadline', headerTooltip: "Deadline", field: 'deadline', cellRendererFramework: CellDateFormatterComponent, width: 100 },
      { headerName: 'Industria/Sector', field: 'sectorNombre' },
      { headerName: 'Responsable de Cliente', field: 'responsableClienteNombre' },
      { headerName: 'Estado', field: 'estadoNombre' },
    ];

    return columnDefs;
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  public loadData() {
    this.psDatosGeneralesService.getAll().subscribe(data => {
      this.rowData = data
    });

    this.psDatosGeneralesService.getSectorList().subscribe(data => this.sectoresList = data);
    this.loadClientes();

  }

  loadClientes() {
    this.lookupCliente.serviceSource = (query: string) => {
      return this._clientesService.getClientesLookup(query);
    };
    this.lookupCliente.serviceSourceById = (id: number) => {
      if (id != null) {
        this.clienteId = id;
        return this._clientesService.getClientesLookupId(id);
      }
    };

    this.lookupCliente.advancedLookupComponent = ClientesComponent;
  }

  public onRowClicked() {
    if (this.isLookup) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.width = '90%';
      // dialogConfig.maxWidth = '80vw';
      dialogConfig.height = '98%';
      // dialogConfig.maxHeight = '80vh';
      dialogConfig.data = {
        isLookup: true
      }

      const ref = this.matDialog.open(PsDatosGeneralesEditComponent, dialogConfig);
      ref.afterOpened().subscribe(() => {
      });

      ref.afterClosed().subscribe(resp => {
        if (resp) {
          this.loadData();
        }
      })
    } else {
      this._router.navigateByUrl('proyecto-significativo/create');
    }
  }

  public onActionRemoveClick(data: any) {
    this.delete(data.id);
  }

  delete(id) {

  }

  onDownloadExcel() {
    this.psDatosGeneralesService.getPSExcel();
  }

  searchFilter(event: KeyboardEvent): void {
    const input = (event.target as HTMLInputElement).value;
    this.searchSubject.next(input); // Emite el valor al subject
  }

  importFilter() {
    this.importeSubject.next();
  }

  handleSearch(searchText: string): void {
    this.search = searchText;
    this.filterSubmit();
  }

  filterSubmit() {
    this.psDatosGeneralesService.getAll(this.importe, this.search, this.clienteId, this.sectorId).subscribe(data => this.rowData = data);
  }

  onFilter() {
    if (this.clienteId === null) {
      this.clienteId = ''
    }
    if (this.importe === null) {
      this.importe = ''
    }

    this.filterSubmit()
  }

}
